import { useState, useEffect} from "react";
import {
  Spinner
} from "@heroui/react";
// import {
//   Divider, Card, CardHeader, CardBody
// } from "@heroui/react";
import UnderConstruction from "../../components/UnderConstruction";

const Dashboard = () => {

    const [loading, setLoading] = useState<boolean>(true);

    // const completedLastWeek = "1";
    // const rollovercalls = "100";
    // const scheduledcallsthisweek = "1";
    // const unassignedCallsThisWeek = "1";

    const fetchData = async () => {
        setLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <main className={`flex flex-col p-4 ${loading ? "opacity-50 pointer-events-none" : ""}`}>
        {/* KPI Cards */}
            {(loading) && (
                <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-[9998]">
                <Spinner size="lg" color="primary" />
                </div>
            )}
            <div className="w-36 mx-8 my-8">
                <UnderConstruction /> 
            </div>
            This page is currently under construction. Please check back later.
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-screen-lg w-full mx-auto mb-4 pb-4">
            <Card><CardHeader><p className="text-md ">Completed Calls Last Week</p></CardHeader><Divider /><CardBody className="flex items-center justify-center text-3xl">{completedLastWeek}</CardBody><Divider /></Card>
            <Card><CardHeader><p className="text-md">Rollover Calls</p></CardHeader><Divider /><CardBody className="flex items-center justify-center text-3xl">{rollovercalls}</CardBody><Divider /></Card>
            <Card><CardHeader><p className="text-md">Scheduled Calls this week</p></CardHeader><Divider /><CardBody className="flex items-center justify-center text-3xl">{scheduledcallsthisweek}</CardBody><Divider /></Card>
            <Card><CardHeader><p className="text-md">Unassigned Calls this week</p></CardHeader><Divider /><CardBody className="flex items-center justify-center text-3xl">{unassignedCallsThisWeek}</CardBody></Card>
            </div> */}
        </main>
    );
  };

export default Dashboard;